module.exports = __webpack_public_path__ + "static/media/play-w64.2b907243.svg";